(() => {
  const populateVariants = (item, options, variants) => {
    const quickShopContainer = item.closest('[data-quick-shop]')
    const quickShopClass = quickShopContainer.getAttribute('data-quick-shop')
    const container = item.closest('[data-quick-shop-item]')
		const message = container.querySelector('[data-quick-shop-size-message]')
		const sizeContainer = item.closest('[data-quick-shop-size-container]')
		let template = ''
		let sizeIndex = null

		for (let i = 0; i < options.length; i++) {
			if (options[i].hasOwnProperty('name') && options[i].name === 'Size') {
				sizeIndex = i + 1
			} else if (options[i] === 'Size') {
        sizeIndex = i + 1
      }
		}

		if (sizeIndex === null) return

		const variantAvailable = []
		const variantSizes = []

    for (let i = 0; i < variants.length; i++) {
			if (variantSizes.indexOf(variants[i]['option' + sizeIndex]) !== 0) {
				const variant = variants[i]
				const id = variant.id
				const available = variant.available
				const disabled = available ? '' : ' disabled'
        let name = variant['option' + sizeIndex]

				if (typeof name !== 'undefined') {
					if (!available && 'hiddenOOSSizes' in window && Array.isArray(window.hiddenOOSSizes) && window.hiddenOOSSizes.indexOf(name.toLowerCase()) >= 0) {
						continue
					}

					name = name.replace('AU', '')
					name = name.replace('US', '')
					name = name.replace('iPhone', '')
					name = name.replace('SHOE', '')
					name = name.replace('One Size', 'ONE SIZE')
					name = name.replace('ONE SIZE', 'ONE SIZE')

					variantAvailable.push(variant.available)
					variantSizes.push(variant['option' + sizeIndex])
					template += `
            <li class="${quickShopClass}-size__item${disabled}">
              <button
                type="button"
                class="${quickShopClass}-size__button"
                data-quick-shop-size
                data-quick-shop-id="${id}"
                data-quick-shop-available="${available}"
              >${name.trim()}</button>
            </li>
          `
				}
			}
		}
    window.QuickShopPopulateVariants = populateVariants

		if (variantSizes.length === 1) {
			message.textContent = 'Add to my bag'
		}

    const firstVariantAvailable = variantAvailable[0]
		const allVariantsAvailableSame = variantAvailable.every((element) => { return element === firstVariantAvailable })

		if (firstVariantAvailable === false && allVariantsAvailableSame) {
			item.classList.add('hidden-size-mobile')
		}

		const allVariantsSizeSame = variantSizes.every((element) => { return element === variantSizes[0] }) && variantSizes.length > 1

		if (allVariantsSizeSame) {
			sizeContainer.classList.add('hidden')
		} else {
      item.innerHTML = template
		}
	}

  window.initQuickShop = (selector = null, resizeImages = true) => {
		if (selector === null) {
			selector = '[data-quick-shop]'
		}

    const selectors = document.querySelectorAll(selector)
    selectors.forEach(item => {
      if (item.hasAttribute('data-quick-shop-intialized')) {
				return
			}

      item.setAttribute('data-quick-shop-intialized', '')

      // Resize for Nosto images
			if (resizeImages) {
        const quickShopContainer = item.closest('[data-quick-shop]')
        const quickShopClass = quickShopContainer.getAttribute('data-quick-shop')
        const images = item.querySelectorAll('[data-quick-shop-image]')

        images.forEach(image => {
					const imageDimensions = quickShopClass == 'quick-shop-carousel' ? '_400x542.jpg' : '_600x813.jpg'
					const pathData = image.getAttribute('src')

					if (pathData.indexOf(imageDimensions) === -1) {
						const path = pathData.replace('.jpg', imageDimensions)
						image.setAttribute('src', path)
					}
				})
			}

      // Sizes
      const sizes = item.querySelectorAll('[data-quick-shop-sizes]')
      sizes.forEach(size => {
				const data = size.getAttribute('data-quick-shop-sizes')
				const handle = data.split('/products/')[1].split('?')[0]

        if (size.hasAttribute('data-variants')) {
					populateVariants(size, size.getAttribute('data-options'), size.getAttribute('data-variants'))
				} else {
					// Only get variants if size is empty
          fetch(`/products/${handle}.js`)
            .then((res) => res.text())
            .then((response) => {
              response = JSON.parse(response)
              populateVariants(size, response.options, response.variants)
            })
            .catch((e) => {
              console.error(e)
            })
				}
      })

      // Center Swiper Buttons
      const alignButtons = () => {
        const buttons = item.querySelectorAll('[data-quick-shop-buttun-holder]')
        const primaryMedia = item.querySelectorAll('[data-quick-shop-item-media]')[0]

        if (buttons && primaryMedia) {
          const mediaMedian = primaryMedia.offsetHeight / 2
          buttons.forEach(button => {
            const buttonMedian = button.offsetHeight / 2
            const top = mediaMedian - buttonMedian
            button.style.top = `${top}px`
          })
        }
      }

      setTimeout(() => {
        alignButtons()
      }, 750)

      document.addEventListener('resizeEnded', () => {
        alignButtons();
      });

      // Homepage
			const title = item.querySelector('[data-quick-shop-title]')
			const titleOverride = item.closest('[data-quick-shop-title-override]')

			if (title && titleOverride) {
				title.textContent = titleOverride.getAttribute('data-quick-shop-title-override')
        item.classList.add('loaded')
			}
    })
	}

  // Events
  document.addEventListener('click', (e) => {
    if (e.target.matches('[data-quick-shop-size]')) {
      const item = e.target
      const container = item.closest('[data-quick-shop-item]')
      const id = item.getAttribute('data-quick-shop-id')
      const available = item.getAttribute('data-quick-shop-available')
      const message = container.querySelector('[data-quick-shop-size-message]')
      const messageText = message.innerText || message.textContent

      const data = {
        id: id,
        quantity: 1
      }

      if (available != 'false') {
        message.textContent = 'Added to Bag!'
        item.classList.add('active')
        container.classList.add('quickadd-mobile')

        requestAnimationFrame(() => {
          if (!window.location.pathname == '/cart') {
            document.querySelector('cart-drawer').open();
          }
          window.addToBag(data)
        });

        setTimeout(() => {
          const nostoAttribution = container.closest('[nosto-attribution]')
          if ('nostojs' in window && nostoAttribution) {
            const productIdElement = container.querySelector('[data-product]')
            if (productIdElement) {
              const productId = productIdElement.getAttribute('data-product')
              window.nostojs(api => api.recommendedProductAddedToCart(productId, nostoAttribution.getAttribute('nosto-attribution')))
            }
          }
        }, 1000)

        setTimeout(() => {
          if (container.classList.contains('quickadd-mobile')) {
            container.classList.remove('quickadd-mobile')
          }
          message.textContent = messageText
        }, 1600)
      }
    }

    if (e.target.matches('[data-quick-shop-quickadd]')) {
      const item = e.target
      const container = item.closest('[data-quick-shop-item]')
      const containers = document.querySelectorAll('[data-quick-shop-item].quickadd')
      containers.forEach(cont => {
        if (cont != container) {
          cont.classList.remove('quickadd')
        }
      })
      container.classList.toggle('quickadd')
    }

    if (!e.target.matches('[data-quick-shop-quickadd]')) {
      const containers = document.querySelectorAll('[data-quick-shop-item].quickadd')
      containers.forEach(container => {
        container.classList.remove('quickadd')
      })
    }
  })

  // document.addEventListener('touchstart', (e) => {
  //   if (e.target.matches('[data-wishlist-button]')) {
  //     e.target.click()
  //   }
  // })

  document.addEventListener('resizeEnded', () => {
    const items = document.querySelectorAll('[data-quick-shop-item].quickadd')
    items.forEach(item => {
      item.classList.remove('quickadd')
    });
  });

  document.addEventListener('reloadProductPage', () => {
    window.initQuickShop()
  })

  // Init
  window.initQuickShop()
})();